import * as bootstrap from 'bootstrap';
import { initClarity } from './clarity';

declare global {
    interface Window {
        scrollToElementById: (id: string) => void;
    }
}

initClarity();

/**
 * Generates an avatar taking the initials of a string
 * @param name the name to change to an avatar
 * @returns a Data Url to embed in an img element
 */
export const generateAvatar = (name: string): string => {
    let initials = name.split(' ').map(function (str) { return str ? str[0].toUpperCase() : ""; }).join('');
    let canvas = document.createElement('canvas');
    let radius = 30.0;
    let margin = 0.0;
    canvas.width = radius * 2 + margin * 2;
    canvas.height = radius * 2 + margin * 2;

    // Get the drawing context
    let ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.arc(radius + margin, radius + margin, radius, 0, 2 * Math.PI, false);
    ctx.closePath();
    ctx.fillStyle = "#F7F0FF";
    ctx.fill();
    ctx.fillStyle = "#8E6ABF";
    ctx.font = "bold 30px Arial";
    ctx.textAlign = 'center';
    ctx.fillText(initials, radius + 1, radius * 4 / 3 + margin);
    return canvas.toDataURL();
}

export const showHideAll = (show: boolean, el: Element) => {
    let collapseElementList: any = document.querySelectorAll("#DeskViewContent .accordion-collapse");// document.querySelectorAll('.accordion-collapse');

    for (let element of collapseElementList) {
        let collapseItem = bootstrap.Collapse.getOrCreateInstance(element);

        if (show) {
            collapseItem.show();
        }
        else {
            if (element.classList.contains('show')) {
                // Only hide if it's currently shown
                collapseItem.hide();
            }
        }
    }
}

export const syncElementWidth = (referenceElement: HTMLElement, targetElement: HTMLElement) => {
    const syncMethod = () => {
        const referenceWidth = window.getComputedStyle(referenceElement).width;
        //targetElement.style.maxWidth = `${referenceElement.offsetWidth}px`;

        targetElement.style.setProperty('max-width', referenceWidth, 'important');
    }
    syncMethod();
    window.onresize = () => {
        syncMethod();
    }
}
export const scrollToTop = () => {
    window.scrollTo(0, 0);
}
export const downloadFile = (url: string, fileName: string, authorizationToken?: string): boolean => {
    try {
        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = fileName ?? '';
        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
        return true;
    } catch (e) {
        console.error('Download failed:', e);
        return false;
    }
}

export const kotobeeEmbed = {
    init: function (iframeEl, height) {
        if (iframeEl) {
            iframeEl.style.height = height + "px";
        }
    }
};

document.addEventListener("DOMContentLoaded", () => {
    let tooltips: bootstrap.Tooltip[] = [];
    bootstrap.Tooltip.Default.allowList.dl = [];
    bootstrap.Tooltip.Default.allowList.dt = [];
    bootstrap.Tooltip.Default.allowList.dd = [];

    window.addEventListener("load", () => {
        let tooltip = new bootstrap.Tooltip(document.body, {
            selector: '[data-bs-toggle="tooltip"],[rel="tooltip"]',
            container: "body",
            trigger: "hover"
        });
        tooltips.push(tooltip);
    });
});
window.bootstrap = require("bootstrap");
window.scrollToElementById = (id:string) => {
    var el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};